import * as Types from '../../@types/graphql-types';

import gql from 'graphql-tag';
export type RegisterLoginMutationVariables = Types.Exact<{ [key: string]: never }>;

export type RegisterLoginMutation = {
	__typename?: 'Mutation';
	registerLogin: { __typename?: 'RegisterPayload'; loginId: string };
};

export const RegisterLoginDocument = gql`
	mutation RegisterLogin {
		registerLogin {
			loginId
		}
	}
`;
